const statues = [
  { id: 1, name: 'Pending' },
  { id: 2, name: 'Approved' },
  { id: 3, name: 'Reject' },
  { id: 4, name: 'HasBeenUpdated', exclude: true },
];

export default statues;
